import { Search } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment } from '@mui/material';
import { TextField } from '@mui/material';


function SearchBar({setSearchText, searchText}) {



  return (
    <>
    <TextField
          className="search-desktop"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
          onChange={(event) => {
            setSearchText(event.target.value);
          }}
          value={searchText}
          placeholder="Search for videos"
          name="search"
        />
    </>
  )
}

export default SearchBar